export enum Vastauskoodi {
  RESPONSE_REJECTED = '1',
  PAPER_RESPONSE_RECEIVED = '2',
  RESPONDENT_REFUSED = '3',
  INFORMATION_AVAILABLE = '4',
}
